// import React, { useState, useEffect } from 'react';
// import CustomButton from "./CustomButton";
// import { Translate } from './LanguageChanger';

// let resolution = window.RESOLUTION;


// const AuthFailModal = ({
//   shouldShowError,
//   errTitle,
//   errDescription,
//   errIcon,
//   button,
//   iconWdth,
//   iconHeight,
//   modalOKButtonHandler,
//   modalCANCELButtonHandler
// }) => {
//   const [selectedBtnIndx, setSelectedBtnIndx] = useState(0); // Manage index with state

//   const styles = {
//     ModalContainer: {
//       display: shouldShowError ? 'flex' : 'none',
//       flexDirection: 'column',
//       background: 'transparent',
//       width: '100vw',
//       height: '100vh',
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       backgroundRepeat: 'no-repeat',
//       overflow: 'hidden',
//       position: 'absolute',
//       top:"0",
//         zIndex: '100',
//     },
//   };

//   useEffect(() => {
//     if (shouldShowError) {
//       window.addEventListener('keydown', ModalScreenKeyHandler);
//     }
//     return () => {
//       window.removeEventListener('keydown', ModalScreenKeyHandler);
//     };
//   }, [shouldShowError, selectedBtnIndx]); // Re-run when `shouldShowError` or `selectedBtnIndx` changes

//   const ModalScreenKeyHandler = (event) => {
//     switch (event.keyCode) {
//       // case 40: // Down arrow
//       //   if (selectedBtnIndx === 0) {
//       //     setSelectedBtnIndx(1); // Move to Cancel button
//       //   }
//       //   break;
//       // case 38: // Up arrow
//       //   if (selectedBtnIndx === 1) {
//       //     setSelectedBtnIndx(0); // Move back to OK button
//       //   }
//       //   break;
//       case 13: // Enter key
//         if (selectedBtnIndx === 0) {
//           localStorage.clear();
//           modalOKButtonHandler(button[0]); // Handle OK action
//         } else if (selectedBtnIndx === 1) {
//           modalCANCELButtonHandler(); // Handle Cancel action
//         }
//         break;
//       default:
//         break;
//     }
//   };

//   const handleOk = () =>{
//     modalOKButtonHandler(button[0]);
//   }

//   // const handleCancel = () =>{
//   //   modalCANCELButtonHandler();
//   // }

//   return (
//     <div style={styles.ModalContainer}>
//       <div
//         style={{
//           overflow: 'hidden',
//           width: '100vw',
//           height: '100vh',
//           position: 'absolute',
//           background: '#000000',
//           opacity: 0.7,
//         }}
//       ></div>
//       <div
//         style={{
//           overflow: 'hidden',
//           position: 'absolute',
//           width: '100vw',
//           height: '30vh',
//           background: '#181818',
//           marginTop: '70vh',
//           zIndex: '2',
//         }}
//       >
//         <div
//           style={{
//             overflow: 'hidden',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             width: '17vw',
//             height: '30vh',
//             position: 'absolute',
//             background: '#0E1653',
//           }}
//         >
//           <img src={errIcon} style={{ width: iconWdth, height: iconHeight }} />
//         </div>
//         <div
//           style={{
//             overflow: 'hidden',
//             display: 'flex',
//             width: '50vw',
//             height: '30vh',
//             position: 'absolute',
//             background: '#0E1653',
//             marginLeft: '17vw',
//           }}
//         >
//           <div
//             style={{
//               position: 'absolute',
//               fontSize: '32px',
//               marginLeft: '50px',
//               marginTop: '10vh',
//               color: '#FFFFFF',
//             }}
//           >
//            {/* <Translate langKey={errTitle} /> */}
//            {typeof errTitle === "object"? <><Translate langKey={errTitle.x} />{" " + errTitle.y} </> : <Translate langKey={errTitle} />}
           
//           </div>
//           <div
//             style={{
//               position: 'absolute',
//               fontSize: '24px',
//               marginLeft: '50px',
//               marginTop: '15vh',
//               color: '#FFFFFF',
//             }}
//           >
//             {console.log(errDescription, "errDesc")}
//              {typeof errDescription === "object"? <> {errDescription.y}, <Translate langKey={errDescription.x} /></> : <Translate langKey={errDescription} />}
//             {/* <Translate langKey={errDescription} /> */}
//             {/* {errDescription} */}
//           </div>
//         </div>
//         <div
//           style={{
//             overflow: 'hidden',
//             display: 'flex',
//             width: '35vw',
//             height: '30vh',
//             position: 'absolute',
//             background: '#0E1653',
//             marginLeft: '63vw',
//           }}
//         >
//           {/* <CustomButton
//             fontSize={resolution === "FHD" ? "26px" : "18px"}
//             defaultSelected={selectedBtnIndx === 0} // Highlight if selected
//             // width={resolution === "FHD" ? "600px" : "169px"}
//             height={resolution === "FHD" ? "80px" : "53px"}
//             top={resolution === "FHD" ? "120px" : "53px"}
//             onClick={handleOk}
//             style={{
//               width: resolution === "FHD" ? "50vh" : "45vh" // Change color if selected
//             }}
//           >
//             {/* {button[0]} */}
//             {/* <Translate langKey={button[0]} />
//           </CustomButton> */} 

//             <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 style={{
//                   width: "90%", // Use full container width
//                   marginBottom: "16px", // Space between buttons
//                   textAlign: "center", // Center button text
//                   position: "relative", // Ensure button is positioned correctly
//                   top: "8rem", // Center vertically
//                 }}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>

          
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthFailModal;


import React, { useState, useEffect } from 'react';
import CustomButton from "./CustomButton";
import { Translate } from './LanguageChanger';
import { QRCodeCanvas } from "qrcode.react";
import gameQr from "../assets/ic_app_qr.png";
let resolution = window.RESOLUTION;


const AuthFailModal = ({
  premiumQr,
  shouldShowError,
  errTitle,
  errDescription,
  errIcon,
  button,
  iconWdth,
  iconHeight,
  modalOKButtonHandler,
  modalCANCELButtonHandler
}) => {
  const [selectedBtnIndx, setSelectedBtnIndx] = useState(0); // Manage index with state

  const styles = {
    ModalContainer: {
      display: shouldShowError ? 'flex' : 'none',
      flexDirection: 'column',
      background: 'transparent',
      width: '100vw',
      height: '100vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      overflow: 'hidden',
      position: 'absolute',
      top:"0",
      zIndex: '100',
    },
  };

  useEffect(() => {
    if (shouldShowError) {
      window.addEventListener('keydown', ModalScreenKeyHandler);
    }
    return () => {
      window.removeEventListener('keydown', ModalScreenKeyHandler);
    };
  }, [shouldShowError, selectedBtnIndx]); // Re-run when `shouldShowError` or `selectedBtnIndx` changes

  const ModalScreenKeyHandler = (event) => {
    switch (event.keyCode) {
      // case 40: // Down arrow
      //   if (selectedBtnIndx === 0) {
      //     setSelectedBtnIndx(1); // Move to Cancel button
      //   }
      //   break;
      // case 38: // Up arrow
      //   if (selectedBtnIndx === 1) {
      //     setSelectedBtnIndx(0); // Move back to OK button
      //   }
      //   break;
      case 13: // Enter key
        if (selectedBtnIndx === 0) {
          
          if(button[0]!=="Okay, Got it")
           { 
            localStorage.clear();
          modalOKButtonHandler(button[0]);}// Handle OK action

          else{
             modalOKButtonHandler(button[0])
          }
        } 
        
        else if (selectedBtnIndx === 1) {
          modalCANCELButtonHandler(); // Handle Cancel action
        }
        break;
      default:
        break;
    }
  };

  const handleOk = () =>{
    // window.appReload();
    if (button[0] === "session-desc") {
      window.appReload();
      modalOKButtonHandler(button[0]);
    } else { 
      modalOKButtonHandler(button[0]);
     }
  }

  // const handleCancel = () =>{
  //   modalCANCELButtonHandler();
  // }

  return (
    <div style={styles.ModalContainer}>
      <div
        style={{
          overflow: 'hidden',
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          background: '#000000',
          opacity: 0.7,
        }}
      ></div>
      <div
        style={{
          overflow: 'hidden',
          position: 'absolute',
          width: '100vw',
          height: '30vh',
          background: '#181818',
          marginTop: '70vh',
          zIndex: '2',
        }}
      >
        <div
          style={{
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '17vw',
            height: '30vh',
            position: 'absolute',
            background: '#000037',
          }}
        >
             {errTitle=="Subscribewatch"&& <QRCodeCanvas
                  value={"https://www.wavespb.com/subscription"}
                  size={180}          // size in px
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"          // error correction level (L, M, Q, H)
                  includeMargin={true}
                />}
          {/* {errTitle=="GamePlay"&& <QRCodeCanvas
                  value={gameQr}
                  size={180}          // size in px
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"          // error correction level (L, M, Q, H)
                  includeMargin={true}
                />} */}
                   {errTitle=="GamePlay"&& <img src={gameQr} style={{ width: "200px", height: "200px" }} />}
                 
          {errIcon&&<img src={errIcon} style={{ width: iconWdth, height: iconHeight }}
          
           />}
        </div>
        <div
          style={{
            overflow: 'hidden',
            display: 'flex',
           ...(errTitle.x === "RentAvailable" ? { width: "68vw" }:{width:"50vw"}),
            height: '30vh',
            position: 'absolute',
            background: '#000037',
              ...(errTitle.x === "RentAvailable" ? { marginLeft: "2vw" }:{marginLeft: '17vw'}),
          }}
        >
          <div
            style={{
              position: 'absolute',
              fontSize: '37px',
              ...(errTitle.x === "RentAvailable" ? { marginLeft: "50px" }:{marginLeft: '24px'}),
              marginTop: '9vh',
              color: '#FFFFFF',
            }}
          >
           {/* <Translate langKey={errTitle} /> */}
           {typeof errTitle === "object"? <><Translate langKey={errTitle.x} />{" " + errTitle.y} </> : <Translate langKey={errTitle} />}
           
          </div>
        {errDescription === "session-desc" ? (
     <div
      style={{
       position: "absolute",
      fontSize: "38px",
      fontWeight: 500,
      marginLeft: "20px",
      marginTop: "13.1vh",
      color: "#FFFFFF",
    }}
  >
    {console.log(errDescription, "errDesc")}
    {typeof errDescription === "object" ? (
      <>
        {errDescription.y}, <Translate langKey={errDescription.x} />
      </>
    ) : (
      <Translate langKey={errDescription} />
    )}
  </div>
            ) : (
       <div
     style={{
      position: "absolute",
      fontSize: "28px",
      ...(errTitle.x === "RentAvailable"
        ? { marginLeft: "46px" }
        : { marginLeft: "19px" }),
      marginTop: "15vh",
      color: "#939393",
    }}
  >
    {console.log(errDescription, "errDesc")}
    {typeof errDescription === "object" ? (
      <>
        {errDescription.y}, <Translate langKey={errDescription.x} />
      </>
    ) : (
      <Translate langKey={errDescription} />
    )}

    <p>
      {errTitle.x === "RentAvailable" && (
        <Translate langKey={"rentalDescriptionMsg"} />
      )}
    </p>
  </div>
)}

          
        </div>
        <div
          style={{
            overflow: 'hidden',
            display: 'flex',
             ...(errTitle.x === "RentAvailable" ? { width: "37vw" }:{width:"37vw"}),
            height: '30vh',
            position: 'absolute',
            background: '#000037',
            marginLeft: '63vw',
          }}
        >
          {/* <CustomButton
            fontSize={resolution === "FHD" ? "26px" : "18px"}
            defaultSelected={selectedBtnIndx === 0} // Highlight if selected
            // width={resolution === "FHD" ? "600px" : "169px"}
            height={resolution === "FHD" ? "80px" : "53px"}
            top={resolution === "FHD" ? "120px" : "53px"}
            onClick={handleOk}
            style={{
              width: resolution === "FHD" ? "50vh" : "45vh" // Change color if selected
            }}
          >
            {/* {button[0]} */}
            {/* <Translate langKey={button[0]} />
          </CustomButton> */} 

            <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 0}
                height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "90%", // Use full container width
                  marginBottom: "16px", // Space between buttons
                  textAlign: "center", // Center button text
                  position: "relative", // Ensure button is positioned correctly
                  top: "8rem", // Center vertically
                  marginLeft:"4px"
                }}
                onClick={handleOk}
              >
                <Translate langKey={button[0]} />
              </CustomButton>

          
        </div>
      </div>
    </div>
  );
};

export default AuthFailModal;